import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

const PRIMARY = '#3eb574';
const DARK = '#0f172a';

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = [
    { to: '/', label: '首页' },
    { to: '/features', label: '功能' },
    { to: '/pricing', label: '价格' },
    { to: '/cases', label: '案例' },
    { to: '/faq', label: '帮助' },
  ];

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: scrolled ? 'rgba(255,255,255,0.92)' : 'transparent',
      backdropFilter: scrolled ? 'blur(12px)' : 'none',
      WebkitBackdropFilter: scrolled ? 'blur(12px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(226,232,240,0.5)' : 'none',
      transition: 'all 0.3s',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', height: 68, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <img src="/assets/images/logo.jpg" style={{ width: 36, height: 36, borderRadius: 10, objectFit: 'cover' }} alt="佳达掌柜" />
          <span style={{ fontWeight: 700, fontSize: 17, color: DARK, letterSpacing: '-0.3px' }}>佳达掌柜</span>
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex" style={{ gap: 4, alignItems: 'center' }}>
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              style={({ isActive }) => ({
                padding: '6px 14px', borderRadius: 6, fontSize: 14, fontWeight: 500,
                color: isActive ? PRIMARY : '#475569',
                backgroundColor: isActive ? `${PRIMARY}18` : 'transparent',
                transition: 'all 0.15s', textDecoration: 'none', display: 'block',
              })}
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        {/* Desktop CTAs */}
        <div className="hidden md:flex" style={{ gap: 10, alignItems: 'center' }}>
          <Link to="/pricing" style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            padding: '8px 18px', fontSize: 13, fontWeight: 700,
            borderRadius: 10, background: 'white', color: DARK, border: '2px solid #e2e8f0',
            textDecoration: 'none', transition: 'all 0.18s',
          }}>查看价格</Link>
          <button style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            padding: '8px 18px', fontSize: 13, fontWeight: 700,
            borderRadius: 10, background: PRIMARY, color: 'white', border: '2px solid transparent',
            cursor: 'pointer', transition: 'all 0.18s',
          }}>免费体验</button>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setOpen(!open)}
          className="flex md:hidden"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, flexDirection: 'column' }}
          aria-label={open ? '关闭菜单' : '打开菜单'}
        >
          <div style={{ width: 22, height: 2, background: DARK, marginBottom: 5, borderRadius: 2, transition: 'all 0.2s', transform: open ? 'rotate(45deg) translate(5px,5px)' : 'none' }} />
          <div style={{ width: 22, height: 2, background: DARK, marginBottom: 5, borderRadius: 2, opacity: open ? 0 : 1, transition: 'all 0.2s' }} />
          <div style={{ width: 22, height: 2, background: DARK, borderRadius: 2, transition: 'all 0.2s', transform: open ? 'rotate(-45deg) translate(5px,-5px)' : 'none' }} />
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div style={{ background: 'white', borderTop: '1px solid #f1f5f9', padding: '12px 24px 20px' }}>
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              onClick={() => setOpen(false)}
              style={({ isActive }) => ({
                display: 'block', padding: '11px 0', fontSize: 15, fontWeight: 500,
                color: isActive ? PRIMARY : '#334155', borderBottom: '1px solid #f1f5f9',
                textDecoration: 'none',
              })}
            >
              {l.label}
            </NavLink>
          ))}
          <div style={{ marginTop: 16 }}>
            <button style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              width: '100%', padding: '12px 24px', fontSize: 14, fontWeight: 700,
              borderRadius: 10, background: PRIMARY, color: 'white', border: 'none',
              cursor: 'pointer',
            }}>免费体验</button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
